/**
 * "You're Confirmed" page: Add to Calendar dropdown.
 * Wires hrefs and Apple .ics from JSON config in each [data-cfd-cal-root] section.
 */
(function () {
  function escIcsValue(s) {
    return String(s)
      .replace(/\\/g, '\\\\')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,')
      .replace(/\n/g, '\\n');
  }

  function initRoot(root) {
    var el = root.querySelector('script[type="application/json"][data-cfd-config]');
    if (!el || !el.textContent) return;
    var cfg;
    try {
      cfg = JSON.parse(el.textContent.trim());
    } catch (e) {
      return;
    }

    var title = cfg.title || '';
    var location = cfg.location || '';
    var landingUrl = cfg.landingUrl || '';
    var base = (cfg.descriptionBase || '').trim();
    var description = base
      ? base + (landingUrl ? '\n\nEvent details: ' + landingUrl : '')
      : landingUrl
        ? 'Event details: ' + landingUrl
        : '';
    var startUTC = cfg.startUTC || '';
    var endUTC = cfg.endUTC || '';
    var startISO = cfg.startISO || '';
    var endISO = cfg.endISO || '';
    var icsUid = cfg.icsUid || 'event@allurecommerce.com';
    var icsFileName = cfg.icsFileName || 'event.ics';

    var enc = encodeURIComponent;

    var google = root.querySelector('[data-cfd-cal-google]');
    if (google) {
      google.href =
        'https://calendar.google.com/calendar/render?action=TEMPLATE' +
        '&text=' +
        enc(title) +
        '&dates=' +
        startUTC +
        '/' +
        endUTC +
        '&details=' +
        enc(description) +
        '&location=' +
        enc(location);
    }

    var outlook = root.querySelector('[data-cfd-cal-outlook]');
    if (outlook) {
      outlook.href =
        'https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent' +
        '&subject=' +
        enc(title) +
        '&startdt=' +
        startISO +
        '&enddt=' +
        endISO +
        '&body=' +
        enc(description) +
        '&location=' +
        enc(location);
    }

    var office = root.querySelector('[data-cfd-cal-office]');
    if (office) {
      office.href =
        'https://outlook.office.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent' +
        '&subject=' +
        enc(title) +
        '&startdt=' +
        startISO +
        '&enddt=' +
        endISO +
        '&body=' +
        enc(description) +
        '&location=' +
        enc(location);
    }

    var yahoo = root.querySelector('[data-cfd-cal-yahoo]');
    if (yahoo) {
      yahoo.href =
        'https://calendar.yahoo.com/?v=60' +
        '&title=' +
        enc(title) +
        '&st=' +
        startUTC +
        '&et=' +
        endUTC +
        '&desc=' +
        enc(description) +
        '&in_loc=' +
        enc(location);
    }

    var apple = root.querySelector('[data-cfd-cal-apple]');
    if (apple) {
      var ics = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Allure Commerce//Shopify Deluxe//EN',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        'UID:' + icsUid,
        'DTSTAMP:' + startUTC,
        'DTSTART:' + startUTC,
        'DTEND:' + endUTC,
        'SUMMARY:' + escIcsValue(title),
        'DESCRIPTION:' + String(description).replace(/\\/g, '\\\\').replace(/\n/g, '\\n'),
        'LOCATION:' + escIcsValue(location)
      ];
      if (landingUrl) {
        ics.push('URL:' + escIcsValue(landingUrl));
      }
      ics = ics.concat([
        'BEGIN:VALARM',
        'TRIGGER:-P1D',
        'ACTION:DISPLAY',
        'DESCRIPTION:Reminder: ' + (title || 'Event') + ' tomorrow',
        'END:VALARM',
        'BEGIN:VALARM',
        'TRIGGER:-PT2H',
        'ACTION:DISPLAY',
        'DESCRIPTION:Reminder: ' + (title || 'Event') + ' in 2 hours',
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR'
      ]);
      var icsBody = ics.join('\r\n');
      apple.setAttribute('download', icsFileName);
      apple.href = 'data:text/calendar;charset=utf-8,' + enc(icsBody);
    }

    var btn = root.querySelector('[data-cfd-cal-btn]');
    var menu = root.querySelector('[data-cfd-cal-menu]');
    if (!btn || !menu) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      menu.classList.toggle('is-open');
    });

    document.addEventListener('click', function (e) {
      if (!btn.contains(e.target) && !menu.contains(e.target)) {
        menu.classList.remove('is-open');
      }
    });

    var links = menu.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function () {
        setTimeout(function () {
          menu.classList.remove('is-open');
        }, 100);
      });
    }
  }

  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function countdownLabelForDays(days) {
    if (days === 7) return 'One Week Away';
    if (days > 1) return days + ' Days Away';
    if (days === 1) return '1 Day Away';
    if (days === 0) return 'Today';
    return 'See You Soon';
  }

  function refreshCountdownBadges() {
    var panelWraps = document.querySelectorAll(
      '.countdown-badge--panel[data-countdown-event]'
    );
    for (var p = 0; p < panelWraps.length; p++) {
      var wrap = panelWraps[p];
      var numEl = wrap.querySelector('[data-countdown-badge-num]');
      var ann = wrap.querySelector('[data-countdown-badge-announcer]');
      var eventYmd = wrap.getAttribute('data-countdown-event') || '2026-05-12';
      var parts = String(eventYmd).split('-');
      if (parts.length < 3) continue;
      var y = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10) - 1;
      var day = parseInt(parts[2], 10);
      var eventDay = startOfDay(new Date(y, m, day));
      var today = startOfDay(new Date());
      var days = Math.round((eventDay - today) / 86400000);
      var n = days > 0 ? days : 0;
      if (numEl) numEl.textContent = String(n);
      if (ann) ann.textContent = countdownLabelForDays(days);
    }

    var nodes = document.querySelectorAll('[data-countdown-badge-text]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var wrap = el.closest('[data-countdown-event]');
      var eventYmd = wrap ? wrap.getAttribute('data-countdown-event') : '2026-05-12';
      var parts = String(eventYmd || '2026-05-12').split('-');
      if (parts.length < 3) continue;
      var y = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10) - 1;
      var day = parseInt(parts[2], 10);
      var eventDay = startOfDay(new Date(y, m, day));
      var today = startOfDay(new Date());
      var days = Math.round((eventDay - today) / 86400000);
      el.textContent = countdownLabelForDays(days);
    }
  }

  function initCountdownBadges() {
    refreshCountdownBadges();
    setInterval(refreshCountdownBadges, 60 * 60 * 1000);
  }

  function run() {
    var roots = document.querySelectorAll('[data-cfd-cal-root]');
    for (var j = 0; j < roots.length; j++) {
      initRoot(roots[j]);
    }
    initCountdownBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
